module.exports = __webpack_public_path__ + "img/10.21f5cce5.png";